import React, { useEffect } from "react"
import { useCookies } from 'react-cookie';
import moment from 'moment'

export default function Loaded() {
  const [cookies, setCookie] = useCookies([]);
  const isBrowser = typeof window !== "undefined"

  useEffect(() => {
    if (!isBrowser) return

    let laxusWebFrom = cookies['laxus-web-from']
    let fromMagazine = false
    let fromIndentifier = 'others'
    let cookieOption = {
      path: '/',
      expires: moment().add(1, 'days').toDate()
    }

    if (!laxusWebFrom && window.location.pathname.indexOf('magazine') !== -1) {
        fromMagazine = true
        fromIndentifier = 'magazine'
    }
    
    if (!laxusWebFrom) {
        setCookie('laxus-web-from', fromIndentifier, cookieOption)
    }
    
    if (laxusWebFrom === 'magazine') {
        fromMagazine = true
    }

    let adv = null
    let query = window?.location?.search
    
    if (query) {
        const params = new URLSearchParams(query)
    
        if (params.has('adv')) {
          adv = params.get('adv')            
          setCookie('laxus-web-adv', adv, cookieOption)
        }
    }
    
    if (laxusWebFrom === 'magazine') {
        fromMagazine = true
    }

    if (!adv) { 
      adv = cookies['laxus-web-adv']
    }
    
    if (!adv) {
        adv = 'organic'
    }
    
    let paths    = window.location.pathname?.split('/')
    let excludes = ['app', 'pc']
    let pathTrackers = []
    
    paths.forEach((path) => {
        if (path && !excludes.includes(path)) {
            pathTrackers.push(path)
        }
    })
    
    if (fromMagazine) {
        pathTrackers.push('from')
        pathTrackers.push('magazine')
    }
    
    let pathTracker = pathTrackers.join('-')
    let regex = /_/g;
    
    while (pathTracker.match(regex)) {
      pathTracker = pathTracker.replace('_', '-')  
    }

    document.querySelector(".link-adjust-dl").addEventListener('click', (e) => {

      e.preventDefault()
  
      const baseUrl = 'https://app.adjust.com/19vkr47u'
  
      let campaign = adv
      
      let adgroup = pathTracker
  
      if (!adgroup) {
          adgroup = 'undefined'
      }
  
      let creative = e.target.getAttribute('data-adjust-ui-specific')
  
      if (!creative) {
          creative = 'undefined'
      }
  
      let url = `${baseUrl}?campaign=${campaign}&adgroup=${adgroup}&creative=${creative}`
  
      if ((window.innerWidth > 800) && (window.innerHeight > 600)) {
          url = 'https://laxus.co/dl'
      }
      
      window.location.href = url
    })

    console.log(pathTracker)
  })

  return (
    <></>
  )
}
